export default "__VITE_ASSET__D2rmMFSA__";